"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeOutInitializer = exports.TimeoutInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const timeout_1 = require("./timeout");
const TIMEOUT_ERROR = 'Timeout initialization error';
class TimeoutInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(TIMEOUT_ERROR, message);
    }
}
exports.TimeoutInitializationError = TimeoutInitializationError;
class TimeOutInitializer extends web_ui_framework_1.Initializer {
    constructor(session, authenticator) {
        super([session, authenticator]);
        this.launch = () => {
            try {
                return new timeout_1.MbTimeOut(this.session.getInitialized(), this.authenticator.getInitialized());
            }
            catch (e) {
                throw new TimeoutInitializationError(e);
            }
        };
        this.session = session;
        this.authenticator = authenticator;
    }
}
exports.TimeOutInitializer = TimeOutInitializer;
//# sourceMappingURL=timeout.initializer.js.map